import {ApiConfig} from "components/src/api/portal/ApiConfig";
import {AuthApi, PortalApi} from "components/src/api/portal/generated";
import {ChangePassword} from "components/src/auth/ChangePassword";
import {TfaSetupWizard} from "components/src/auth/TfaSetupWizard";
import {startTransition, useState} from "react";
import NavDropdown from "react-bootstrap/NavDropdown";
import {createPortal} from "react-dom";
import {useTranslation} from "react-i18next";

export const PortalAppMenu = () =>
{
    const [showChangePasswordDialog, setShowChangePasswordDialog] = useState(false);
    const [showSetup2FADialog, setShowSetup2FADialog] = useState(false);

    const authApi = new AuthApi(ApiConfig.config());
    const portalApi = new PortalApi(ApiConfig.config());

    /**
     * i18next translation hook
     */
    const {t} = useTranslation('components');

    async function is2FAEnabledFunc()
    {
        // convert to matching function
        return portalApi.portalControllerGetPortalProperties().then(
            (response) => {
                return {
                    data: response.data.tfaEnabled??false,
                    status: response.status,
                    statusText: response.statusText,
                    headers: response.headers,
                    config: response.config,
                }
            }
        )
    }

    return (
        <>
            {/* ChangePassword Modal should be placed outside this menu  */}
            {showChangePasswordDialog && createPortal(
                <ChangePassword changePasswordFunc={(param) => authApi.authControllerChangePortalPassword(param)} onClose={() => setShowChangePasswordDialog(false)}/>,
                document.body
            )}

            {/* TfaSetupWizard Modal should be placed outside this menu */}
            {showSetup2FADialog && createPortal(
                <TfaSetupWizard
                    initFunc={() => authApi.authControllerGenerateTFASecret()}
                    is2FAEnabledFunc={is2FAEnabledFunc}
                    getSecretQRCodeFunc={() => authApi.authControllerGet2FASecretQRCode()}
                    getSecretFunc={() => authApi.authControllerGet2FASecret()}
                    set2FAEnabledFunc={(enabled : boolean) => authApi.authControllerSet2FAEnabled(enabled)}
                    validateOTPFunc={(otpCode : string) => authApi.authControllerValidateTOTP(otpCode)}
                    onClose={() => setShowSetup2FADialog(false)}/>,
                document.body
            )}

            {/* startTransition is required to prevent "A component suspended while responding to synchronous input..." */}
            <NavDropdown.Item onClick={() => startTransition(() => setShowChangePasswordDialog(true))}>
                {t('portal-home.change-password')}
            </NavDropdown.Item>
            <NavDropdown.Divider/>
            <NavDropdown.Item onClick={() => startTransition(() => setShowSetup2FADialog(true))}>
                {t('portal-home.setup-2fa')}
            </NavDropdown.Item>
            <NavDropdown.Divider/>
        </>
    )
}
